// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Link } from 'react-router'
import { Col, Row } from 'react-bootstrap'
import { Message } from '../components/message'
import config from '../config/config.json'
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib'

export class WorkerCertificate extends Component {
    constructor(props) {
        super(props)

        this.path = {
            modules: '/assets/images/Modules/'
        }

        let activeModuleData = this.props.activeModules.filter(result => {
            return (result.name === this.props.activeModule)
        })[0]

        let activeResults = []
        if (this.props.activeProviderId === config.consts.MY_CONTENT_KEY) {
            activeResults = this.props.allResults.filter(result => {
                return ((result.provider_id === null) && (result.enabler_module === this.props.activeModule))
            })
        }
        // Global results for all providers, including those disconnected
        else if (this.props.activeProviderId === config.consts.MY_CERT_KEY) {
            activeResults = this.props.allResults.filter(result => {
                return result.enabler_module === this.props.activeModule
            })
        }
        else {
            activeResults = this.props.allResults.filter(result => {
                return ((result.provider_id === Number(this.props.activeProviderId)) && (result.enabler_module === this.props.activeModule))
            })
        }

        //console.log("Cert results:")
        //console.log(activeResults)

        this.state = {
            activeModuleData: activeModuleData,
            activeResults: activeResults,
            pdfBlob: null,
            pdfLink: null,
        }

        if (this.state.activeModuleData && this.state.activeModuleData.completed) {
            let userName = this.props.appData.first_name + " " + this.props.appData.last_name
            let completionDate = this.getCompletionDate()
            this.generateCertificate(userName, this.props.activeProviderName, this.props.activeModule, completionDate)
        }
    }

    /**
     * Completion date will be the lastest official result date, since any results after the assignment is flagged as finished 
     * are sent to are saved as non-offical (Practice Mode)
     */
    getCompletionDate() {
        // Default fallback to today's date if there is an error
        let today = new Date();
        let completionDate = this.getDateFormatted(today);

        let filteredList = this.state.activeResults.filter(result => {
            return result.official
        })

        filteredList.sort((a, b) => (a.created_at < b.created_at) ? -1 : 1)

        if (filteredList.length > 0) {
            let completionDateUTCString = filteredList[filteredList.length - 1].created_at
            completionDate = this.getDateFormatted(new Date(completionDateUTCString))
        }

        return completionDate
    }

    getDateFormatted(dateObj) {
        return dateObj.getDate() + '/' + (dateObj.getMonth() + 1) + '/' + dateObj.getFullYear()
    }

    componentDidUpdate(prevProps, prevState) {
        /*let activeModuleData = prevProps.activeModules.filter(result=> {
            return (result.name === prevProps.activeModule)
        })[0]

        this.setState({
            activeModuleData: activeModuleData
        })*/
    }

    displayCertificate() {
        let details = "Please wait while we generate your certificate. It will automatically open in a new window."

        if (this.state.activeModuleData && this.state.activeModuleData.completed) {
            return (
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Message
                            text={details}
                        />
                    </Col>
                </Row>
            )
        }
        else {
            return (
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Message
                            text="You have not completed this module."
                        />
                    </Col>
                </Row>
            )
        }
    }

    async generateCertificate(userName, providerName, moduleName, displayDate) {
        try {
            //const fs = require('fs')

            // Fetch an existing PDF document
            const url = window.location.href.replace(window.location.pathname, "") + '/assets/certificates/enabler_cert.pdf'
            const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

            // Load a PDFDocument from the existing PDF bytes
            const pdfDoc = await PDFDocument.load(existingPdfBytes)

            // Embed fonts for use
            const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRomanBoldItalic)
            const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)

            // Get the first page of the document
            const pages = pdfDoc.getPages()
            const firstPage = pages[0]

            // Get the width and height of the first page
            const { width, height } = firstPage.getSize()

            // Get text properties for center alignment
            const userNameFont = timesRomanFont
            const userNameFontSize = 60
            const userNameWidth = userNameFont.widthOfTextAtSize(userName, userNameFontSize)
            const moduleNameFont = helveticaFont
            const moduleNameFontSize = 22
            const moduleNameWidth = moduleNameFont.widthOfTextAtSize(moduleName, moduleNameFontSize)
            const displayDateFont = helveticaFont
            const displayDateFontSize = 18
            const displayDateWidth = displayDateFont.widthOfTextAtSize(displayDate, displayDateFontSize)

            // Draw username
            firstPage.drawText(userName, {
                x: width * 0.5 - userNameWidth / 2,
                y: height * 0.425,
                size: userNameFontSize,
                font: userNameFont,
                color: rgb(0, 0, 0),
            })

            // Draw module name
            firstPage.drawText(moduleName, {
                x: width * 0.5 - moduleNameWidth / 2,
                y: height * 0.24,
                size: moduleNameFontSize,
                font: moduleNameFont,
                color: rgb(0, 0, 0),
            })

            // Draw date
            firstPage.drawText(displayDate, {
                x: width * 0.67 - displayDateWidth / 2,
                y: height * 0.155,
                size: displayDateFontSize,
                font: displayDateFont,
                color: rgb(0, 0, 0),
            })

            // Serialize the PDFDocument to bytes (a Uint8Array)
            const pdfBytes = await pdfDoc.save()

            // Trigger the browser to download the PDF document
            //download(pdfBytes, "enabler_cert.pdf", "application/pdf")

            // Display in browser
            const blob = new Blob([pdfBytes], { type: "application/pdf" })
            const docUrl = URL.createObjectURL(blob)
            const frameHtml = <iframe src={docUrl} title="My Certificate" type="application/pdf" />
            window.open(docUrl)

            this.setState({
                pdfBlob: blob,
                pdfLink: frameHtml,
                //pdfEmbed: <iframe src={this.state.pdfLink} type="application/pdf" />,
            })
        } catch (error) {
            console.log(error)
        }
    }

    prepareBreadcrumb() {
        return (<div className="breadcrumb"><span><Link to="/individual">Training</Link></span>/<span><Link to="/individual">{this.props.activeProviderName}</Link></span>/</div>)
    }

    render() {
        return (
            <section className="worker-certificate">
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <div className="main-header">
                            {this.prepareBreadcrumb()}
                            <h2 className="title">My Certificate</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <section className="module-info">
                            <h3 className="module-title">Module: {this.props.activeModule}</h3>
                        </section>
                    </Col>
                </Row>
                {this.displayCertificate()}
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/workerCertificate.js